import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import PageSeo from "../components/seo/page-seo";

const HEADER_OFFSET = 60;

const Wrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const root = document.documentElement;
    const prevBehavior = root.style.scrollBehavior;
    const app = document.getElementById("app-root");

    app?.setAttribute("data-scroll-resetting", "true");

    document.body.style.overflow = "hidden";

    root.style.scrollBehavior = "auto";

    const doReset = () => {
      if (!hash) {
        window.scrollTo(0, 0);
      } else {
        const id = hash.slice(1);
        const el = document.getElementById(id);
        if (el) {
          const y =
            el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
          window.scrollTo({ top: y, behavior: "auto" });
        } else {
          window.scrollTo(0, 0);
        }
      }

      window.dispatchEvent(new Event("scroll"));

      requestAnimationFrame(() => {
        app?.removeAttribute("data-scroll-resetting");
        document.body.style.overflow = "";
        if (prevBehavior) root.style.scrollBehavior = prevBehavior;
        else root.style.removeProperty("scroll-behavior");
      });
    };

    requestAnimationFrame(doReset);
  }, [pathname, hash]);

  return (
    <>
      <PageSeo pathname={pathname} />
      {children}
    </>
  );
};

export default Wrapper;
